import { startCheckout } from '../utils/checkout';
import { SUPPORT_EMAIL } from '../utils/constants';

const included = [
  'The full desktop app — Windows today, macOS soon, on up to 3 devices',
  'Live support cards + Ask Claude mid-meeting',
  'Voice recognition speaker ID and category-shaped summaries',
  'Next steps into Claude, notes anywhere via MCP',
  'Every future update — free, forever',
];

const Pricing = () => {
  const buy = () => startCheckout('pricing');

  return (
    <section className="pricing" id="pricing">
      <div className="pricing-glow" aria-hidden="true" />
      <div className="section-container pricing-inner">
        <p className="overline overline--center">PRICING</p>
        <h2 className="section-title">Buy once. Own it forever.</h2>
        <p className="section-subtitle">
          One purchase, lifetime use. No subscription of any kind, no per-seat fees, no
          per-meeting metering. You bring your own keys — so you only ever pay your own providers
          for what you use.
        </p>

        <div className="pricing-card">
          <div className="pricing-price">
            <span className="pricing-old mono">$50</span>
            <span className="pricing-new">$25</span>
            <span className="pricing-badge mono">LAUNCH PRICING</span>
          </div>
          <p className="pricing-tagline">
            One-time payment. $25 while we launch — $50 after. Yours for life either way.
          </p>

          <ul className="pricing-included">
            {included.map((item, i) => (
              <li key={i}>
                <span className="pricing-check" aria-hidden="true">
                  ✓
                </span>
                {item}
              </li>
            ))}
          </ul>

          <button className="btn btn-primary pricing-buy" onClick={buy}>
            Buy now — $25 →
          </button>

          <p className="pricing-guarantee mono">
            7-day money-back guarantee — one email to {SUPPORT_EMAIL} · No subscription, ever
            · One purchase, lifetime use
          </p>
        </div>

        <div className="pricing-byo">
          <p className="pricing-byo-title">What you bring</p>
          <div className="pricing-byo-grid">
            <div className="pricing-byo-item">
              <span className="pricing-byo-num mono">01</span>
              <h4>Your Claude subscription</h4>
              <p>
                The app runs on Claude Code with your existing Claude plan (Pro or Max), on your
                machine. We don't resell Claude or mark it up — handoffs land in your real Claude
                history.
              </p>
            </div>
            <div className="pricing-byo-item">
              <span className="pricing-byo-num mono">02</span>
              <h4>Your AssemblyAI key</h4>
              <p>
                Live transcription streams through your own AssemblyAI API key (a free tier
                exists) — you pay them directly for exactly what you transcribe, nothing through
                us.
              </p>
            </div>
          </div>
          <p className="pricing-byo-stat">
            There's <strong>no per-meeting fee and no monthly notetaker subscription</strong>
            {' '}sitting on top. Bring your own AssemblyAI key (there's a free tier) and you're
            billed by them directly for exactly what you transcribe; prefer not to manage a key?
            Your purchase includes transcription credits you can top up as needed. Either way,
            there's no recurring bill.
          </p>
          <p className="pricing-byo-note">
            Solidly doesn't resell your providers or mark them up. Your keys, your accounts,
            your usage.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
